export default {
  p_matpl: {
    title: 'Introduction to MatPL',
    titleP1: `
        The combination of artificial intelligence and traditional computer simulation has become
        a major trend in modern scientific computing. In this trend, the research and application
        of machine learning force fields has become an important direction. Machine learning force
        fields can significantly improve the accuracy and efficiency of molecular dynamics simulations,
        which is of great significance for scientific research and engineering applications.
    `,
    titleP2: `
        Materials Potential Library (MatPL) is an open source software package developed by the Longxun team.
        It is developed from the original PWMLFF and is open source under the GNU license.
        The main function of MatPL is to quickly generate machine learning force fields,
        the accuracy of which is comparable to ab initio molecular dynamics (AIMD).
        This means that using PWMLFF, researchers can obtain high-precision simulation
        results in a short time, greatly improving research efficiency.
    `,
    titleP3: `
        MatPL provides a complete set of solutions, including model training platform,
        libtorch interface solution of Lammps, active learning platform,
        data format conversion tools, etc. In addition, it also provides data and model warehouse,
        as well as detailed user manual. These functions and resources provide users with all-round support,
        allowing users to use MatPL for scientific computing and simulation more conveniently and efficiently.
    `,
    matplT1: 'User Manual',
    matplT1P1: 'The MatPL User Manual provides detailed documentation on the installation, usage, and case studies of the MatPL toolset.',
    matplT2: 'Machine Learning Platform',
    matplT2P1: 'Supports 8 common descriptors, 4 machine learning models, and 2 training optimizers',
    matplT3: 'interface',
    matplT3P1: 'Seamless integration with MatPL models, supporting CPU, GPU multi-card molecular dynamics simulation',
    matplT4: 'active learning platform (support pip install pwact)',
    matplT4P1: `Automatic active learning sampling, fast preparation of MatPL training data,
           support for common first-principles software such as PWmat, VASP, CP2K, DFTB (PWmat integration), etc.`,
    matplT5: 'Structure conversion tool PWdata (support pip install pwdata)',
    matplT5P1: `Supports conversion between PWmat, VASP, CP2K, Lammps, and supports conversion of various structures to pwmlff/npy, extxyz data formats`,
    matplT6: 'Training Dataset Warehouse',
    matplT6P1: 'Baidu Netdisk download:',
    matplT6P2: `It contains AIMD datasets of common systems and some fully trained MatPL models,
              which allows users to quickly reuse datasets and models, saving data preparation and model training costs.`,
    matplT7: 'Test Cases',
    matplT7P1: 'MatPL test results and related cases using MatPL',
  },
  p_ls3df: {
    title: 'Introduction to LS3DF',
    titleP1: `
            LSEDF (Linear Scaling 3D Block Algorithm) is based on the idea of divide and conquer.
            It divides a large system into many small fragments. Each small fragment is calculated
            separately by DFT method, and then the calculated small fragments are combined and
            spliced together to obtain the electronic structure properties of the large system.
            The basis for the implementation of the linear scaling 3D block algorithm is that the
            total energy can be divided into two parts: electrostatic energy and quantum mechanical
            energy (for example, kinetic energy and exchange correlation energy). Among them,
            electrostatic energy is a long-range effect, so a Poisson equation must be solved for the whole,
            and the computationally expensive quantum mechanical energy is a short-range effect,
            so the whole system is divided into small fragments, and the quantum mechanical energy of
            these small fragments is calculated separately, and then the energy calculated by DFT of each
            small fragment is combined to obtain the energy of the whole system. The key problem that needs
            to be solved is how to combine and splice small fragments.
            Beijing Longxun Kuangteng Technology Co., Ltd. has proposed a novel splicing scheme that
            can eliminate the boundary effect through special summation. In this calculation method,
            once the size of the small fragment is determined, in order to obtain a given numerical accuracy,
            the amount of calculation is proportional to the number of small fragments.
            Therefore, we call it the linear scaling 3D block method.
    `,
    titleP2: `
            LS3DF has a wide range of uses and can be used for grain boundary, dislocation, defect,
            amorphous or actual device research. In 2020, Longxun Kuangteng cooperated with the
            Institute of Semiconductors of the Chinese Academy of Sciences to achieve plane wave accuracy
            calculation of a 100,000-atom system on a supercomputing platform (Mstation Cluster,
            hereinafter referred to as Mcluster) with 200 GPUs. In 2022, Longxun Kuangteng worked together
            with Tencent Quantum Laboratory, Tencent Cloud High Performance Computing Product Team,
            and Professor Shi Lin's team of Yancheng Institute of Technology to successfully achieve plane
            wave accuracy first-principles calculation of a super-large-scale system of millions of silicon atoms.
    `,
    ls3dfT1: 'Related Downloads',
    ls3dfT1P1: 'LS3DF installation package download address',
  }
}